import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues, MarketplaceAppPaymentModelValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { HostingIcon } from '@atlassian/mpac-ui';
import { MarketplaceAppUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { PAID_APP_CTA_LABEL_BUY, PAID_APP_CTA_LABEL_START_TRIAL, PAID_APP_CTA_LABEL_SUBSCRIBE, TEST_ID } from "../../../../constants";
import { valueForHosting } from "../../../../utils";
import { CTAKind, PurchaseIntent } from "../../AppListing.types";
import { getAppListingCTAs } from "../../AppListingCTA";
import { HostedByDiv, HostingContainer, HostingParagraph, HostingTitle, HostingTitleSubtext } from "./HostingColumn.styles";
import HostingLicenseGuidance, { HostingLicenseGuidanceText } from "./HostingLicenseGuidance";
export var HostingColumnTitleSubtext = function HostingColumnTitleSubtext(props) {
  if (props.hasPurchaseLink) return /*#__PURE__*/React.createElement(HostingTitleSubtext, null, "Buy this app");
  var paidViaAtlassian = props.paymentModel === MarketplaceAppPaymentModelValues.PaidViaAtlassian;
  var paidAppText = props.purchaseIntent === PurchaseIntent.BUY ? 'Buy this app' : 'Free for 30 days';
  return /*#__PURE__*/React.createElement(HostingTitleSubtext, null, paidViaAtlassian ? paidAppText : 'Get it now');
};

var getHostingColumnBuyLabel = function getHostingColumnBuyLabel(purchaseIntent, hosting) {
  if (purchaseIntent === PurchaseIntent.TRY) {
    return PAID_APP_CTA_LABEL_START_TRIAL;
  }

  return hosting === AtlassianProductHostingTypeValues.Cloud ? PAID_APP_CTA_LABEL_SUBSCRIBE : PAID_APP_CTA_LABEL_BUY;
};

export var getHostingColumnTestId = function getHostingColumnTestId(hosting) {
  var _valueForHosting;

  return valueForHosting(hosting)((_valueForHosting = {}, _defineProperty(_valueForHosting, AtlassianProductHostingTypeValues.Cloud, TEST_ID.HOSTING_SELECTOR_MODAL_COLUMN_CLOUD), _defineProperty(_valueForHosting, AtlassianProductHostingTypeValues.Server, TEST_ID.HOSTING_SELECTOR_MODAL_COLUMN_SERVER), _defineProperty(_valueForHosting, AtlassianProductHostingTypeValues.DataCenter, TEST_ID.HOSTING_SELECTOR_MODAL_COLUMN_DATACENTER), _valueForHosting));
};
export function HostingColumn(_ref) {
  var isHighlighted = _ref.isHighlighted,
      appVersion = _ref.appVersion,
      hosting = _ref.hosting,
      purchaseIntent = _ref.purchaseIntent,
      activeCTAKind = _ref.activeCTAKind,
      appId = _ref.appId,
      appKey = _ref.appKey,
      privateRemotableOnly = _ref.privateRemotableOnly,
      onCTAClick = _ref.onCTAClick,
      trialLicenseActivationLink = _ref.trialLicenseActivationLink,
      licensePurchaseLink = _ref.licensePurchaseLink,
      privateListingsLink = _ref.privateListingsLink,
      artifactDownloadLink = _ref.artifactDownloadLink;
  var isNotAnApp = MarketplaceAppUtils.isNotAnApp(appVersion.deployment);
  var isRemote = MarketplaceAppUtils.isRemoteable(appVersion.deployment);
  var compatibleProducts = // $FlowFixMe: `compatibleProducts` is optionally present in all discriminated unions, flow can't figure that out
  appVersion.deployment.compatibleProducts || [];

  var _getAppListingCTAs = getAppListingCTAs({
    appId: appId,
    appKey: appKey,
    appVersion: appVersion,
    privateRemotableOnly: privateRemotableOnly,
    selectedHosting: hosting,
    onClick: function onClick(e) {
      return onCTAClick(e, hosting, appVersion);
    },
    trialLicenseActivationLink: trialLicenseActivationLink,
    licensePurchaseLink: licensePurchaseLink,
    privateListingsLink: privateListingsLink,
    artifactDownloadLink: artifactDownloadLink
  }),
      PrimaryCTA = _getAppListingCTAs.PrimaryCTA,
      SecondaryCTA = _getAppListingCTAs.SecondaryCTA;

  var activeCloudCTA = PrimaryCTA;
  var activeServerDCCTA = activeCTAKind === CTAKind.SECONDARY && SecondaryCTA ? SecondaryCTA : PrimaryCTA;
  var HostingColumnCTA = hosting === AtlassianProductHostingTypeValues.Cloud ? activeCloudCTA : activeServerDCCTA;
  return /*#__PURE__*/React.createElement(HostingContainer, {
    isHighlighted: isHighlighted,
    "data-testid": getHostingColumnTestId(hosting)
  }, /*#__PURE__*/React.createElement(HostingIcon, {
    type: hosting
  }), /*#__PURE__*/React.createElement(HostingTitle, null, " ", HostingDisplayName[hosting], " "), /*#__PURE__*/React.createElement(HostingColumnTitleSubtext, {
    paymentModel: appVersion.paymentModel,
    hasPurchaseLink: !!appVersion.purchaseUrl,
    purchaseIntent: purchaseIntent
  }), /*#__PURE__*/React.createElement(HostingLicenseGuidance, {
    paymentModel: appVersion.paymentModel,
    compatibleProducts: compatibleProducts,
    hosting: hosting,
    isNotAnApp: isNotAnApp,
    learnMoreUrl: appVersion.learnMoreUrl,
    isRemote: isRemote,
    purchaseIntent: purchaseIntent
  }), /*#__PURE__*/React.createElement(HostedByDiv, null, hosting === AtlassianProductHostingTypeValues.Cloud ? 'Atlassian Hosts' : 'You host'), HostingColumnCTA && /*#__PURE__*/React.createElement(HostingColumnCTA, {
    appearance: isHighlighted ? 'warning' : 'link',
    size: isHighlighted ? 'large' : 'small',
    buyLabel: getHostingColumnBuyLabel(purchaseIntent, hosting),
    autoFocus: isHighlighted
  }));
}
export var DataCenterMayWorkHostingColumn = function DataCenterMayWorkHostingColumn() {
  return /*#__PURE__*/React.createElement(HostingContainer, null, /*#__PURE__*/React.createElement(HostingTitle, null, HostingDisplayName[AtlassianProductHostingTypeValues.DataCenter], " "), /*#__PURE__*/React.createElement(HostingTitleSubtext, null, "Not Available"), /*#__PURE__*/React.createElement(HostingParagraph, null, HostingLicenseGuidanceText.MAYBE_DATACENTER_COMPATIBLE));
};